/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */

import React, { useState, useEffect, useMemo } from "react"
import { useSelector } from "react-redux"
import {
    useToken,
    DownloadMoment,
    Step,
    StepController,
    ContentSection,
    Column,
    Label,
} from "trux"
import { AutoAddMomentToTraceiDDialog } from "../AutoAddMomentToTraceiDDialog"
import { useFluidPlayer } from "trux/dist/organisms/VideoPlayer"

const DownloadMomentWrapper = ({
    forceFullGame,
    onClose,
    history,
    expirationDays,
    onSetStep,
}) => {
    const [step, setStep] = useState("loading")
    const token = useToken("DownloadMomentWrapper")
    const [moment, setMoment] = useState(null)

    const videoContainerRef = useMemo(() => {
        let container = document.querySelector(".VideoContainer")
        let containerRef = { current: null }
        if (container) {
            let containerId = container.id
            containerRef.current = parseInt(
                containerId.replace("video-container-", ""),
                10
            )
        }
        return containerRef
    })

    const { currentMoment, fluidSource, insideMoment } = useFluidPlayer(
        videoContainerRef,
        {
            currentMoment: true,
            fluidSource: true,
        }
    )

    let fullGame = !insideMoment || forceFullGame

    const stateMoment = useSelector((state) => {
        return state.video.value.source
    })

    const game = useSelector((state) => {
        return state.game.value
    })
    const team = useSelector((state) => {
        return state.team.value
    })

    const handleOnClick = (downloadStatus) => {
        setStep("auto-add")
    }

    useEffect(() => {
        if (typeof onSetStep === "function") {
            onSetStep(step)
        }
    }, [step])

    useEffect(() => {
        if (!moment && fluidSource && currentMoment) {
            let fullGameClipId = fluidSource.game_clip_id
            let momentToDownload = null

            if (game && fullGameClipId) {
                if (fullGame) {
                    let fullGameEvent = game.events.filter(function (event) {
                        return event.game_clip_id === fullGameClipId
                    })
                    momentToDownload = fullGameEvent[0]
                    console.log(
                        "DownloadMomentWrapper momentToDownload fullgame",
                        momentToDownload
                    )
                } else {
                    console.log(
                        "DownloadMomentWrapper momentToDownload nowMoment",
                        stateMoment
                    )
                    momentToDownload = stateMoment
                }

                console.log(
                    "DownloadMomentWrapper momentToDownload",
                    momentToDownload,
                    fullGame,
                    fullGameClipId
                )
                setMoment(momentToDownload)
                setStep("download")
            }
        }
    }, [
        fluidSource,
        insideMoment,
        currentMoment,
        game,
        moment,
        stateMoment,
        fullGame,
    ])

    return (
        <StepController step={step}>
            <Step name="loading">
                <ContentSection>
                    <Column>
                        <Label
                            center
                            type={Label.Type.Heading4}
                            marginBottom="4"
                        >
                            TRACE_BOT is booting up
                        </Label>
                    </Column>
                </ContentSection>
            </Step>
            <Step name="download">
                <DownloadMoment
                    item={moment}
                    onClose={onClose}
                    history={history}
                    showChildren={false}
                    expirationDays={expirationDays}
                    handleOnClickDownloadNow={handleOnClick}
                />
            </Step>
            <Step name="auto-add">
                <AutoAddMomentToTraceiDDialog
                    open={true}
                    team={team}
                    token={token}
                    moment={moment}
                    onClose={onClose}
                    title={"Downloaded"}
                    disableAutoAdd={moment?.type === "FullGameVideo"}
                />
            </Step>
        </StepController>
    )
}

export default DownloadMomentWrapper
